import React from "react";

const ASP_Drive = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Drive</h1>
      <p>This is the ASP Drive page content.</p>
    </div>
  );
};

export default ASP_Drive;
